// extracted by mini-css-extract-plugin
module.exports = {"menuItemList":"MenuItemList_menuItemList__15B9v","mainMenuItem":"MenuItemList_mainMenuItem__3dPMc"};